/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { enUS, es, zhCN, fr, de, th, pl, hu, pt, nl, vi, ja, it } from 'date-fns/locale';

export const locales = { 'en-US': enUS, enUS, es, cn: zhCN, zhCN, fr, de, th, pl, hu, pt, nl, vi, ja, it };
